const DEFAULT_PROJECTS = {
  '1512399528_5a2562a8b1dd48.76364494':
  {
    id: '1512399528_5a2562a8b1dd48.76364494',
    name: 'Document Project',
    date: '2017-12-04 14:58:48',
    createdWith: 'easybib',
    shared: false,
    defaultstyle: 'mla8',
    'public': true
  }
}

function getDocumentSetting(key, defaultValue) {
  return window.Office.context.document.settings.get(key) || defaultValue
}

function setDocumentSetting(key, value) {
  window.Office.context.document.settings.set(key, value);
  window.Office.context.document.settings.saveAsync();
}

export default class CitationStorage {

  getProjects() {
    return getDocumentSetting('projects', DEFAULT_PROJECTS)
  }
 
  updateProjectStyle(id, style) {
    const projects = getDocumentSetting('projects', DEFAULT_PROJECTS)
    const project = projects[id]
    project.defaultstyle = style
    setDocumentSetting('projects', projects)
    return project
  }

  getCitations() {
    return getDocumentSetting('citations', [])
  }

  deleteCitation(id) {
    let citations = getDocumentSetting('citations', [])
    citations = citations.filter(citation => citation.id !== id)
    setDocumentSetting('citations', citations)
  }

  addCitation(citation) {
    const citations = getDocumentSetting('citations', [])
    citations.push(citation)
    setDocumentSetting('citations', citations)
  }
}



// WEBPACK FOOTER //
// ./src/CitationStorage.js